import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";

interface Options {
	formId: number;

	year?: number;

	month?: number;

	userId?: number;

	storeId?: number;

	complete?: boolean;

	compliant?: boolean;

	enabled?: boolean;

	onSuccess?: (data: PreviousObservationForm[]) => void;
}

const fetchInstanceByFormId = async ({
	formId,
	userId,
	storeId,
	year,
	month,
	complete
}: Options) => {
	const url = "/observations/instances/all-versions/";

	const params = {
		observationform: formId,
		store: storeId,
		created_for: userId,
		year,
		month,
		complete
	};

	const { data } = await cmsClient.get<
		CMSPaginatedData<PreviousObservationForm>
	>(url, { params });

	return data.results;
};

const useFilterFormInstance = (options: Options) => {
	const { enabled = true, onSuccess } = options;

	return useQuery(
		["previousObservationForm", options],
		() => fetchInstanceByFormId(options),
		{ enabled, onSuccess }
	);
};

export default useFilterFormInstance;
